import React from 'react';
import { Heart, Shirt } from 'lucide-react';
import type { VaultIntent } from '../../../services/vaultService';

interface IntentSwitchProps {
  value: VaultIntent | null;
  onChange: (intent: VaultIntent) => void;
  disabled?: boolean;
  className?: string;
}

const OPTIONS: { value: VaultIntent; label: string; icon: React.ReactNode }[] = [
  { value: 'own', label: 'I own it', icon: <Shirt size={16} /> },
  { value: 'want', label: 'Wishlist', icon: <Heart size={16} /> },
];

// "I own it" / "Wishlist" with a sliding thumb. `null` = not chosen yet
// (the save sheet asks before anything is saved).
const IntentSwitch: React.FC<IntentSwitchProps> = ({ value, onChange, disabled, className = '' }) => {
  const index = value ? OPTIONS.findIndex(o => o.value === value) : -1;
  return (
    <div className={`v-seg v-glass ${className}`} role="radiogroup" aria-label="Owned or wishlist">
      {index >= 0 && (
        <span
          className="v-seg-thumb"
          style={{ width: 'calc((100% - 8px) / 2)', transform: `translateX(${index * 100}%)` }}
          aria-hidden="true"
        />
      )}
      {OPTIONS.map(o => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          aria-pressed={value === o.value}
          disabled={disabled}
          onClick={() => onChange(o.value)}
          className="inline-flex items-center justify-center gap-2 !h-11 disabled:opacity-50"
        >
          {o.icon}
          {o.label}
        </button>
      ))}
    </div>
  );
};

export default IntentSwitch;
